export default [
    'Cold Storage',
    'Data Center',
    'Distribution',
    'Flex',
    'Food Processing',
    'Logistics',
    'Manufacturing',
    'Owner-User',
    'Other',
    'Research & Development',
    'Showroom',
    'Truck Terminal',
    'Vacant',
    'Warehouse',
    'IOS'
];